export const projects = [
  {
    id: 1,
    projectName: "Row House Interior Design",
    location: "Alandi",
    highlights: [
      { label: "", value: "Wooden rafters that add timeless charm" },
      { label: "", value: "Painted glass accents for an artistic touch" },
      { label: "", value: "Veneer finishes to highlight natural textures" },
      { label: "", value: "Wooden flooring for warmth and elegance" },
      { label: "", value: "Contemporary wallpaper to elevate the walls" },
      {
        label: "",
        value:
          "A fully functional tandem kitchen for convenience and efficiency",
      },
      {
        label: "",
        value:
          "False ceiling with a moonlight effect, bringing a cozy and luxurious ambiance",
      },
    ],
    descn: [
      "Our Row House project in Alandi beautifully balances modern interior design with traditional elements, creating a warm yet stylish living space that reflects the client’s vision.",
      "This thoughtful combination of traditional aesthetics with modern functionality makes the home both inviting and practical. Every detail was curated to suit the client’s lifestyle while maintaining a unique, personalized design identity.",
    ],
    mainImg: "/assets/images/projects/row_house/row-thumbnail.jpeg",
    imgs: [
      "/assets/images/projects/row_house/img1.jpeg",
      "/assets/images/projects/row_house/img2.jpeg",
      "/assets/images/projects/row_house/img3.jpeg",
      "/assets/images/projects/row_house/img4.jpeg",
      "/assets/images/projects/row_house/img5.jpeg",
      "/assets/images/projects/row_house/img6.jpeg",
      "/assets/images/projects/row_house/img7.jpeg",
      "/assets/images/projects/row_house/img8.jpeg",
      "/assets/images/projects/row_house/img9.jpeg",
      "/assets/images/projects/row_house/img10.jpeg",
      "/assets/images/projects/row_house/img11.jpeg",
      "/assets/images/projects/row_house/img12.jpeg",
    ],
  },

  {
    id: 2,
    projectName: "2 BHK Apartment Interiors",
    location: "Eden Garden, Vimannagar",
    highlights: [
      {
        label: "",
        value:
          "Sober color palette with matte finishes, focusing on wooden shades for a warm, elegant look",
      },
      {
        label: "",
        value:
          "Music-themed design elements thoughtfully incorporated to reflect the couple’s passion",
      },
      {
        label: "",
        value:
          "Compact kitchen redesigned with ample storage, ensuring functionality without compromising aesthetics",
      },
      {
        label: "",
        value:
          "Kids’ room customized with shelves and wall hangings, creating a playful yet organized space",
      },
      {
        label: "",
        value:
          "A fully functional tandem kitchen for convenience and efficiency",
      },
      {
        label: "",
        value:
          "False ceiling with a moonlight effect, bringing a cozy and luxurious ambiance",
      },
    ],
    descn: [
      "This 2 BHK apartment at Eden Garden, Vimannagar was designed for a couple who wanted a balance of sober, matte-finish interiors with a personalized music-inspired theme. The husband preferred muted wooden tones over bright colors, while the couple’s shared love for music played an important role in shaping the design.",
      "This home perfectly combines practical space management with personalized interiors, resulting in a cozy, functional, and uniquely expressive living environment.",
    ],
    mainImg: "/assets/images/projects/two_bhk/img7.jpeg",
    imgs: [
      "/assets/images/projects/two_bhk/img1.jpeg",
      "/assets/images/projects/two_bhk/img2.jpeg",
      "/assets/images/projects/two_bhk/img3.jpeg",
      "/assets/images/projects/two_bhk/img4.jpeg",
      "/assets/images/projects/two_bhk/img5.jpeg",
      "/assets/images/projects/two_bhk/img6.jpeg",
      "/assets/images/projects/two_bhk/img7.jpeg",
    ],
  },

  {
    id: 3,
    projectName: "2.5 BHK Apartment Interiors",
    location: "Kalashree Society, Nanded City",
    highlights: [
      {
        label: "Civil modifications",
        value:
          "Removed the half wall partition between hall and kitchen to create an open, spacious feel; flooring was also upgraded for a modern touch",
      },
      {
        label: "Living room",
        value:
          "Added a unique swing with a backrest that can flip, adding both charm and functionality",
      },
      {
        label: "Kids’ room",
        value: "Introduced a Murphy bed to save space in the compact layout",
      },
      {
        label: "Kitchen",
        value:
          "Designed as a tandem kitchen with tall unit, utility unit, and breakfast counter, ensuring excellent storage and efficiency",
      },
      {
        label: "Bedrooms",
        value:
          "Tall wardrobes and strategic wall paneling to make the rooms look larger and taller",
      },
      {
        label: "Colors & finishes",
        value:
          "Used bright colors in furniture, wallpaper, and painting to create a lively and spacious atmosphere",
      },
    ],
    descn: [
      "This 2.5 BHK apartment at Kalashree Society, Nanded City had a small carpet area, which made space planning the key focus of the project. Our design approach emphasized smart furniture, space-saving solutions, and functional layouts to ensure every inch of the home was utilized effectively.",
      "The result is a compact yet highly functional apartment interior, where clever design choices made the home feel more open, vibrant, and practical for everyday living.",
    ],
    mainImg: "/assets/images/projects/two_and_half_bhk/thumbnail.jpeg",
    imgs: [
      "/assets/images/projects/two_and_half_bhk/img1.jpeg",
      "/assets/images/projects/two_and_half_bhk/img2.jpeg",
      "/assets/images/projects/two_and_half_bhk/img3.jpeg",
      "/assets/images/projects/two_and_half_bhk/img4.jpeg",
      "/assets/images/projects/two_and_half_bhk/img5.jpeg",
      "/assets/images/projects/two_and_half_bhk/img6.jpeg",
      "/assets/images/projects/two_and_half_bhk/img7.jpeg",
      "/assets/images/projects/two_and_half_bhk/img8.jpeg",
      "/assets/images/projects/two_and_half_bhk/img9.jpeg",
      "/assets/images/projects/two_and_half_bhk/img10.jpeg",
      "/assets/images/projects/two_and_half_bhk/img11.jpeg",
      "/assets/images/projects/two_and_half_bhk/img12.jpeg",
      "/assets/images/projects/two_and_half_bhk/img13.jpeg",
      "/assets/images/projects/two_and_half_bhk/img14.jpeg",
      "/assets/images/projects/two_and_half_bhk/img15.jpeg",
      "/assets/images/projects/two_and_half_bhk/img16.jpeg",
      "/assets/images/projects/two_and_half_bhk/img17.jpeg",
    ],
  },

  {
    id: 4,
    projectName: "3 BHK Luxury Apartment Interiors",
    location: "Kalpataru, Baner",
    highlights: [
      {
        label: "",
        value:
          "Smart home automation for ultimate convenience and modern living",
      },
      {
        label: "",
        value:
          "Premium materials such as veneer for furniture, rich marble, and striking onyx surfaces",
      },
      {
        label: "",
        value:
          "Civil work enhancements to ensure both durability and design precision",
      },
      {
        label: "",
        value: "Stretch ceiling installation for a sleek and contemporary look",
      },
      {
        label: "",
        value:
          "A theme-based kids’ room, bringing creativity and vibrancy to the space",
      },
      {
        label: "",
        value:
          "An advanced modular kitchen, designed for efficiency, comfort, and style",
      },
    ],
    descn: [
      "This 3 BHK luxury apartment in Kalpataru, Baner was designed for a client who envisioned a high-class, posh, and ultra-modern living space. The project seamlessly blends luxury, technology, and Vastu principles, creating a home that is both sophisticated and harmonious.",
      "Every corner of this home reflects the client’s desire for a modern yet vastu-compliant lifestyle, with attention to detail, functionality, and luxurious finishes. The result is a bespoke apartment interior that embodies elegance, innovation, and timeless appeal.",
    ],
    mainImg: "/assets/images/projects/three_bhk/thumbnail.jpeg",
    imgs: [
      "/assets/images/projects/three_bhk/thumbnail.jpeg",
      "/assets/images/projects/three_bhk/img1.jpeg",
      "/assets/images/projects/three_bhk/img2.jpeg",
      "/assets/images/projects/three_bhk/img3.jpeg",
      "/assets/images/projects/three_bhk/img4.jpeg",
      "/assets/images/projects/three_bhk/img5.jpeg",
      "/assets/images/projects/three_bhk/img6.jpeg",
      "/assets/images/projects/three_bhk/img7.jpeg",
      "/assets/images/projects/three_bhk/img8.jpeg",
      "/assets/images/projects/three_bhk/img9.jpeg",
      "/assets/images/projects/three_bhk/img10.jpeg",
      "/assets/images/projects/three_bhk/img11.jpeg",
      "/assets/images/projects/three_bhk/img12.jpeg",
      "/assets/images/projects/three_bhk/img13.jpeg",
      "/assets/images/projects/three_bhk/img14.jpeg",
      "/assets/images/projects/three_bhk/img15.jpeg",
      "/assets/images/projects/three_bhk/img16.jpeg",

      "/assets/images/projects/three_bhk/img17.jpeg",
      "/assets/images/projects/three_bhk/img18.jpeg",
      "/assets/images/projects/three_bhk/img19.jpeg",
      "/assets/images/projects/three_bhk/img20.jpeg",
      "/assets/images/projects/three_bhk/img21.jpeg",
      "/assets/images/projects/three_bhk/img22.jpeg",
      "/assets/images/projects/three_bhk/img23.jpeg",
      "/assets/images/projects/three_bhk/img24.jpeg",
      "/assets/images/projects/three_bhk/img25.jpeg",
      "/assets/images/projects/three_bhk/img26.jpeg",
      "/assets/images/projects/three_bhk/img27.jpeg",
      "/assets/images/projects/three_bhk/img28.jpeg",
      "/assets/images/projects/three_bhk/img29.jpeg",
    ],
  },

  {
    id: 5,
    projectName: "3 BHK Apartment Interiors ",
    location: "Nico Garden, Vimannagar",
    highlights: [
      {
        label: "",
        value:
          "Sober and minimal designs for false ceiling, furniture, pooja mandir, kids’ room, and kitchen",
      },
      {
        label: "",
        value:
          "Tile replacement in the entire home, including bathrooms, with smart tile combinations to make the compact bathrooms appear more spacious",
      },
      {
        label: "",
        value:
          "Optimized storage solutions such as a utility unit, showcase, loft cupboards, and a fully functional tandem kitchen",
      },
      {
        label: "",
        value:
          "Use of bright yet balanced color schemes, ensuring the home feels lively without compromising on elegance",
      },
    ],
    descn: [
      "This 3 BHK apartment at Nico Garden, Vimannagar was designed with the client’s vision of a modern home featuring bright colors and simple designs. Our approach focused on creating a fresh, vibrant, and functional living space that feels open, comfortable, and stylish.",
      "By blending modern aesthetics with practical functionality, we transformed this apartment into a contemporary home that is both beautiful and efficient for everyday living.",
    ],
    mainImg: "/assets/images/projects/nico_garden/thumbnail.jpeg",
    imgs: [
      "/assets/images/projects/nico_garden/thumbnail.jpeg",
      "/assets/images/projects/nico_garden/img1.jpeg",
      "/assets/images/projects/nico_garden/img2.jpeg",
      "/assets/images/projects/nico_garden/img3.jpeg",
      "/assets/images/projects/nico_garden/img4.jpeg",
      "/assets/images/projects/nico_garden/img5.jpeg",
      "/assets/images/projects/nico_garden/img6.jpeg",
      "/assets/images/projects/nico_garden/img7.jpeg",
      "/assets/images/projects/nico_garden/img8.jpeg",
      "/assets/images/projects/nico_garden/img9.jpeg",
      "/assets/images/projects/nico_garden/img10.jpeg",
    ],
  },

  {
    id: 6,
    projectName: "Tesla Hi-Tech Imaging and Diagnostic Centre ",
    location: "Pimpri Chinchwad",
    highlights: [
      {
        label: "",
        value:
          "Elegant and spacious lobby and waiting area designed for patient comfort",
      },
      {
        label: "",
        value:
          "Custom reception table and front desk designed for functionality and easy workflow",
      },
      {
        label: "",
        value:
          "High-quality tiling and false ceiling work to ensure hygiene and modern aesthetics",
      },
      {
        label: "",
        value:
          "Well-planned doctors’ cabins, testing rooms, MRI, and CT scan areas designed with smooth circulation and privacy in mind",
      },
      {
        label: "",
        value:
          "The design reflects the brand’s high-tech image while maintaining a soothing and organized atmosphere, essential for patient well-being and staff efficiency.",
      },
    ],
    descn: [
      "At Tesla Hi-Tech Imaging and Diagnostic Centre, Pimpri, our goal was to design a modern, professional, and patient-focused healthcare environment. The interiors were carefully planned to ensure both visual appeal and practical efficiency for day-to-day operations.",
    ],
    mainImg: "/assets/images/projects/tesla-hi-tech/6.jpeg",
    imgs: [
      "/assets/images/projects/tesla-hi-tech/1.jpeg",
      "/assets/images/projects/tesla-hi-tech/2.jpeg",
      "/assets/images/projects/tesla-hi-tech/3.jpeg",
      "/assets/images/projects/tesla-hi-tech/4.jpeg",
      "/assets/images/projects/tesla-hi-tech/5.jpeg",
      "/assets/images/projects/tesla-hi-tech/6.jpeg",
    ],
  },

  {
    id: 7,
    projectName: "SP Super Speciality Clinic – Pediatric Clinic - Dr. Ashlesha Dighe",
    location: "Wakad,Pune",
    highlights: [
      {
        label: "",
        value:
          "Comfortable and welcoming lobby and waiting area for parents and children.",
      },
      {
        label: "",
        value:
          "Well-planned doctors’ cabins designed for consultation comfort and privacy.",
      },
      {
        label: "",
        value:
          "Organized testing area ensuring smooth functionality.",
      },
      {
        label: "",
        value:
          "A special room for kids, creatively designed with playful colors and décor to make young patients feel relaxed and cheerful.",
      },
      {
        label: "",
        value:
          "This project highlights our expertise in pediatric clinic interiors, combining clean, hygienic design with warmth and vibrancy suited for children.",
      },
    ],
    descn: [
      "At SP Super Speciality Clinic, we designed a space that balances professional sophistication with a child-friendly environment, tailored for a pediatric surgeon.",
    ],
    mainImg: "/assets/images/projects/sp_super-speciality/2.jpeg",
    imgs: [
      "/assets/images/projects/sp_super-speciality/1.jpeg",
      "/assets/images/projects/sp_super-speciality/2.jpeg",
      "/assets/images/projects/sp_super-speciality/3.jpeg",
    ],
  },

  {
    id: 8,
    projectName: "Asian Institute of Men’s Health & Urology Clinic - Dr. R. K. Shimpi",
    location: "Hadapsar,Pune",
    highlights: [
      {
        label: "",
        value:
          "Spacious lobby and seating area designed to provide a comfortable waiting experience for patients",
      },
      {
        label: "",
        value:
          "Elegant reception area with a clean, organized layout to handle high footfall smoothly.",
      },
      {
        label: "",
        value:
          "Luxurious doctor’s cabin with refined finishes that reflect sophistication and professionalism.",
      },
      {
        label: "",
        value:
          "In-house pharmacy planned for easy accessibility and functionality.",
      },
      {
        label: "",
        value:
          "False ceiling design enhancing the ambiance with proper lighting and acoustics.",
      },
      {
        label: "",
        value:
          "Operation theatre setup meeting high standards of hygiene, design precision, and utility",
      },
    ],
    descn: [
      "At the Asian Institute of Men’s Health & Urology Clinic, designed for Dr. R. K. Shimpi, we created a space that reflects both luxury and medical precision. The design aimed to deliver a calm, professional, and premium healthcare environment that ensures comfort for patients and efficiency for staff.",
    ],
    mainImg: "/assets/images/projects/asian_institute/3.jpeg",
    imgs: [
      "/assets/images/projects/asian_institute/1.jpeg",
      "/assets/images/projects/asian_institute/2.jpeg",
      "/assets/images/projects/asian_institute/3.jpeg",
      "/assets/images/projects/asian_institute/4.jpeg",
      "/assets/images/projects/asian_institute/5.jpeg",
      "/assets/images/projects/asian_institute/6.jpeg",
      "/assets/images/projects/asian_institute/7.jpeg",
      "/assets/images/projects/asian_institute/8.jpeg",
      "/assets/images/projects/asian_institute/9.jpeg",
      "/assets/images/projects/asian_institute/10.jpeg",
    ],
  },


];
